module.exports = "<nav class=\"leftsettingbox\">\r\n        <ul class=\"list-unstyled settinglist\">  \r\n          \r\n            <li><a [routerLink]=\"['secondaryLiveTrackingReport']\"   routerLinkActive=\"selected\"><strong>Live Tracking</strong></a></li>\r\n            <li><a [routerLink]=\"['secondaryAssignment']\"   routerLinkActive=\"selected\"><strong>Secondary Assignment</strong></a></li>\r\n        </ul>     \r\n</nav> \r\n<router-outlet></router-outlet> \r\n "


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/secondary/secondaryReport.component.html
// module id = ./src/app/reports/secondary/secondaryReport.component.html
// module chunks = main